package br.com.texeratx.boardgametimeapp.ui.screens.matches.detail

import br.com.texeratx.boardgametimeapp.ui.screens.expansions.model.ExpansionUI
import br.com.texeratx.boardgametimeapp.ui.screens.matches.model.MatchListItemUI

data class MatchDetailUiState(
    val isLoading: Boolean = false,
    val error: String? = null,
    val match: MatchListItemUI? = null,
    val expansions: List<ExpansionUI> = emptyList(),
    val isDeleting: Boolean = false,
    val showDeleteConfirmation: Boolean = false
)
